import React from "react";
import { PositionRoleRef } from "services/positions.service";
import { groupRolesByArea } from "./positions-helpers";

/** A position's pareigybės as chips, grouped by sphere. */
export default function PositionRoleChips({
  roles,
  emptyLabel,
}: {
  roles: PositionRoleRef[];
  emptyLabel?: string;
}) {
  if (!roles.length) {
    return <span className="text-sm text-gray-400">{emptyLabel || "—"}</span>;
  }
  const groups = groupRolesByArea(roles);
  // The sphere caption only earns its place once it distinguishes something.
  const showArea = groups.length > 1 || groups.some((group) => group.areaName);
  return (
    <div className="flex flex-col gap-1">
      {groups.map((group) => (
        <div key={group.areaId || "none"} className="flex flex-wrap items-center gap-1">
          {showArea && group.areaName && (
            <span className="mr-0.5 text-xs font-medium text-gray-500">{group.areaName}:</span>
          )}
          {group.roles.map((role) => (
            <span
              key={role.id}
              className="inline-flex items-center rounded-md bg-gray-100 px-1.5 py-0.5 text-xs text-gray-800 ring-1 ring-inset ring-gray-200"
            >
              {role.name}
            </span>
          ))}
        </div>
      ))}
    </div>
  );
}
